const defaultSortWithScore = (defaultSort) => (params) => {
  if (params.q) {
    return ['-score'];
  }

  return defaultSort;
};

export default defaultSortWithScore;
